import React from 'react';

const DerivationTree = ({ tree }) => {
  if (!tree) return null;

  // Function to get a formatted node label
  const getNodeLabel = (node) => {
    if (node.type === 'SYMBOL') {
      return `<SYMBOL,${node.value}>`;
    } else if (node.type === 'PIPE') {
      return `<PIPE>`;
    } else if (node.type === 'LCBRA') {
      return `<LCBRA>`;
    } else if (node.type === 'RCBRA') {
      return `<RCBRA>`;
    } else if (node.type === 'LCURLY') {
      return `<LCURLY>`;
    } else if (node.type === 'RCURLY') {
      return `<RCURLY>`;
    } else if (node.type === 'LSQBRA') {
      return `<LSQBRA>`;
    } else if (node.type === 'RSQBRA') {
      return `<RSQBRA>`;
    } else {
      return node.type;
    }
  };

  // Visual tree rendering with boxes and lines
  const renderVisualTree = (node, isRoot = true) => {
    if (!node) return null;
    
    const nodeLabel = getNodeLabel(node);
    const hasChildren = node.children && node.children.length > 0;
    
    // Determine node type styling
    let nodeClass = "tree-node";
    if (node.type === 'SYMBOL') {
      nodeClass += " symbol-node";
    } else if (node.type === 'PIPE' || node.type === 'LCBRA' || node.type === 'RCBRA' || 
               node.type === 'LCURLY' || node.type === 'RCURLY' || node.type === 'LSQBRA' || node.type === 'RSQBRA') {
      nodeClass += " special-node";
    } else if (node.type === 'regular') {
      nodeClass += " regular-node";
    } else if (node.type === 'alternative') {
      nodeClass += " alternative-node";
    } else if (node.type === 'sequence') {
      nodeClass += " sequence-node";
    } else if (node.type === 'element') {
      nodeClass += " element-node";
    }

    return (
      <div className={`tree-node-container ${isRoot ? 'root-node' : ''}`}>
        <div className={nodeClass}>
          {nodeLabel}
        </div>
        
        {hasChildren && (
          <div className="tree-children-container">
            {/* Always add a vertical line from parent to children regardless of number */}
            <div className="tree-vertical-line"></div>
            
            {/* Horizontal line for multiple children */}
            {node.children.length > 1 && <div className="tree-horizontal-line"></div>}
            
            <div className="tree-children">
              {node.children.map((child, index) => (
                <div key={index} className="tree-child">
                  {/* Always add a vertical line to each child */}
                  <div className="tree-child-line"></div>
                  {renderVisualTree(child, false)}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  // Fallback to ASCII-art tree if needed
  const renderTreeAscii = (node, prefix = '', isLast = true, level = 0) => {
    if (!node) return [];

    const lines = [];
    const connector = isLast ? '└── ' : '├── ';
    const childPrefix = isLast ? '    ' : '│   ';
    
    // Prepare node content
    let nodeContent = getNodeLabel(node);

    // Add current node
    if (level === 0) {
      lines.push(nodeContent);
    } else {
      lines.push(prefix + connector + nodeContent);
    }

    // Add children
    if (node.children && node.children.length > 0) {
      const lastIndex = node.children.length - 1;
      node.children.forEach((child, index) => {
        const childLines = renderTreeAscii(
          child,
          prefix + childPrefix,
          index === lastIndex,
          level + 1
        );
        lines.push(...childLines);
      });
    }

    return lines;
  };

  // Generate ASCII tree as fallback
  const treeLines = renderTreeAscii(tree);

  return (
    <div className="derivation-tree-visualization">
      <div className="visual-tree">
        {renderVisualTree(tree)}
      </div>
      
      <details>
        <summary>Pokaż reprezentację ASCII</summary>
        <pre className="ascii-tree">
          {treeLines.join('\n')}
        </pre>
      </details>
    </div>
  );
};

export default DerivationTree; 